/* eslint-disable import/prefer-default-export */
import { QueryFunctionContext } from '@tanstack/react-query';
import getAxiosInstance from '../axiosClient';
import type { iAnalyticsDataList, } from '../../interfaces/sampleInterface';
// @flow

const requestCustomization = getAxiosInstance(process.env.REACT_APP_CHOICE_2_V2_CUSTOMIZATION_API_URL);

const url = '/site';

const propsData = {
  properties: [
    {
      id: 'b4aaf306-926a-4676-bf33-43c376174b02',
      url: 'property1.com'
    },
    {
      id: '03f79b38-9234-4936-b1cc-91c3e54f8170',
      url: 'property2.com'
    }
  ]
};

export async function getPremiumSites(context: QueryFunctionContext): Promise<iAnalyticsDataList> {
  const [, queryPayload] = context.queryKey;
  const { pCode } = queryPayload;
  // const data = await requestCustomization.get(
  //   `${url}/premium/pcode/${pCode}`,
  // );
  return propsData;
}
